import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import {
    Switch,
    Route,
    Redirect
} from 'react-router-dom';
import { scroller } from 'react-scroll';
import Header from '../../components/Header';
import DetFooter from '../../components/Footer';
import HomePage from '../HomePage';
import RulesPage from '../RulesPage';
import SurveyPage from '../SurveyPage';
import ProfilePage from '../ProfilePage';
import ErrorBoundary from '../../components/ErrorBoundary';
import {fetchStudentDetails, fetchSearchOptions} from '../../modules/student';
import get from 'lodash/get'
import 'sanitize.css/sanitize.css';
import './App.css';

class App extends Component {
  componentDidMount() {
    this.props.fetchStudentDetails();
    this.props.fetchSearchOptions();
  }

    handleSkipLinkClick = (anchor) => {
        const clickedElem = document.getElementById(anchor)
        scroller.scrollTo(anchor, {
            duration: 100,
            smooth: true,
        })
        clickedElem.focus()
    }

  render() {
    const currentRoute = this.props.location.pathname;
    const isProfileRoute = currentRoute === '/profile' || currentRoute === '/survey';
    const appMainClassName = isProfileRoute? "app-main app-main--profile" : "app-main";

    const showSurvey = this.props.isLoggedIn && !this.props.isSurveyTaken
    return (
      <div className="app-container">
        <ul className="skip-links">
          <li><button onClick={() => this.handleSkipLinkClick('headerLink')}>Skip to Header</button></li>
          <li><button onClick={() => this.handleSkipLinkClick('mainLink')}>Skip to Main Content</button></li>
          <li><button onClick={() => this.handleSkipLinkClick('footerLink')}>Skip to Footer</button></li>
        </ul>
        <Header isOnSurvey={showSurvey} />
        <main className={appMainClassName}>
            <ErrorBoundary root>
                <span id="mainLink" className="sr-only" tabIndex="0">Main Content</span>
                <Switch>
                  <Route path="/survey" render={(props) =>
                      !showSurvey ?
                          <Redirect to={this.props.isLoggedIn ? "/profile" : "/"} /> :
                          <SurveyPage {...props} />
                  } />
                  <Route path="/rules" component={RulesPage} />
                    {this.props.isLoggedIn &&
                    <Route path="/profile"
                           render={() => showSurvey ?
                               <Redirect to="/survey" /> :
                               <ProfilePage />
                           }
                    />}
                  <Route
                      exact
                      path="/"
                      render={() => showSurvey ?
                          <Redirect to="/survey"/> :
                          <HomePage />
                      }
                  />
                </Switch>
            </ErrorBoundary>
        </main>
        <DetFooter />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchStudentDetails,
  fetchSearchOptions
}, dispatch);

const mapStateToProps = state => {
    return({
        isLoggedIn: !!get(state, 'student.studentDetails.studentId'),
        isSurveyTaken: ['0', 'ASK_AGAIN'].includes(get(state, 'student.studentDetails.surveyTaken')),
    })
}
// withRouter needed because of Hash history
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
